/**
 * Shopify Multi-Currency Handler
 * 
 * Uses Shopify's native Markets & localization system.
 * Your base/local prices remain unchanged — Shopify converts them
 * at real-time exchange rates for display and checkout.
 *
 * Requirements:
 *  - Shopify Markets enabled (Settings > Markets)
 *  - Multiple currencies enabled per market
 *  - Theme must support localization (most modern themes do)
 */

const currencySelector = {

  /**
   * Update the store currency using Shopify's localization form.
   * This uses the native /localization endpoint — no third-party API needed.
   */
  updateCurrency(currencyCode) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';

    const hiddenCurrency = document.createElement('input');
    hiddenCurrency.type = 'hidden';
    hiddenCurrency.name = 'currency_code';
    hiddenCurrency.value = currencyCode;

    // Preserve the current page after currency switch
    const hiddenReturn = document.createElement('input');
    hiddenReturn.type = 'hidden';
    hiddenReturn.name = 'return_to';
    hiddenReturn.value = window.location.pathname + window.location.search;

    // CSRF token required by Shopify
    const hiddenToken = document.createElement('input');
    hiddenToken.type = 'hidden';
    hiddenToken.name = 'authenticity_token';
    hiddenToken.value = this.getAuthToken();

    form.appendChild(hiddenCurrency);
    form.appendChild(hiddenReturn);
    form.appendChild(hiddenToken);

    document.body.appendChild(form);
    form.submit();
  },

  /**
   * Retrieve Shopify's CSRF authenticity token from the page meta tag.
   */
  getAuthToken() {
    const meta = document.querySelector('meta[name="shopify-checkout-api-token"]');
    if (meta) return meta.content;

    // Fallback: parse from existing localization forms on the page
    const existingInput = document.querySelector('input[name="authenticity_token"]');
    if (existingInput) return existingInput.value;

    console.warn('Currency Selector: Could not find authenticity token. Add {% form "localization" %} somewhere in your theme to expose it.');
    return '';
  },

  /**
   * Format a price (in cents) for display in a given currency.
   * Useful for custom price display outside of Liquid.
   * 
   * @param {number} cents - Price in the smallest currency unit
   * @param {string} currencyCode - ISO currency code e.g. "USD"
   * @returns {string} Formatted price string
   */
  formatPrice(cents, currencyCode) {
    const amount = cents / 100;
    try {
      return new Intl.NumberFormat(navigator.language, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      return `${currencyCode} ${amount.toFixed(2)}`;
    }
  },

  /**
   * Initialize: sync the selector dropdown with the currently active currency.
   */
  init() {
    const selector = document.getElementById('currency-selector');
    if (!selector) return;

    // Current currency is already set via Liquid's `selected` attribute,
    // but this ensures JS state is consistent if the selector is dynamically injected.
    const activeCurrency = document.documentElement.getAttribute('data-currency') || null;
    if (activeCurrency) {
      selector.value = activeCurrency;
    }
  }
};

document.addEventListener('DOMContentLoaded', () => currencySelector.init());